import { type ReactNode } from 'react';

import { WizardSeparator } from 'common/components/Wizard/WizardSeparator';

import { WizardItem } from './WizardItem';
import { type WizardItemStatus } from './wizardModels';

export type StepConfig = {
  label: string;
  content: ReactNode;
};

type WizardProps = {
  steps: StepConfig[];
  currentStep: number;
  className?: string;
};

function getStepStatus(
  stepNumber: number,
  currentStep: number,
): WizardItemStatus {
  if (stepNumber < currentStep) {
    return 'completed';
  }
  if (stepNumber === currentStep) {
    return 'current';
  }
  return 'pending';
}

export const Wizard = ({ steps, currentStep, className }: WizardProps) => {
  const totalSteps = steps.length;
  return (
    <div className={className}>
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const status = getStepStatus(stepNumber, currentStep);

        return (
          <div className="flex flex-col" key={stepNumber}>
            <WizardItem
              title={step.label}
              index={stepNumber}
              content={step.content}
              status={status}
            />
            {index !== totalSteps - 1 && <WizardSeparator />}
          </div>
        );
      })}
    </div>
  );
};
